export enum RateModel {
  Inflation = "Inflation",
  Moderate = "Moderate",
  Balanced = "Balanced",
  Aggressive = "Aggressive",
  Stock = "Stock",
  Treasury = "Treasury"
}

export enum ReturnSequence {
  Historical= "Historical",
  BadTiming = "BadTiming"
}

class RateModels {

  getRate = (year: number, sequence: ReturnSequence, model: RateModel): number => {
    if (sequence === ReturnSequence.Historical) {
      if (year >= 0 && year < HistoricRates.length) {
        return (HistoricRates[year][model])
      }
    } else if (sequence === ReturnSequence.BadTiming) {
      if (year >= 0 && year < BadTimingRates.length) {
        return (BadTimingRates[year][model])
      }
    }
    return 0
  }

  getRateSequence = (sequence: ReturnSequence, model: RateModel): number[] => {
    if (sequence === ReturnSequence.Historical) {
      return (HistoricRates.map((item: any) => item[model]))
    } else if (sequence === ReturnSequence.BadTiming) {
      return (BadTimingRates.map((item: any) => item[model]))
    }
    return []
  }

  getRateModelLabel = (model: RateModel): string => {
    let label = ""

    switch (model) {
      case RateModel.Aggressive:
        label = "Aggressive - 70/30 Stocks/Bonds"
        break
      case RateModel.Balanced:
        label = "Balanced - 60/40 Stocks/Bonds"
        break
      case RateModel.Moderate:
        label = "Moderate - 50/50 Stocks/Bonds"
        break
      case RateModel.Inflation:
        label = "Inflation"
        break
      case RateModel.Stock:
        label = "US Stock Market"
        break
      case RateModel.Treasury:
        label = "Intermediate Term Treasury"
        break
    }

    return label
  }
}

// Hisorical Rates updated on 5/27/2025 based on 1978-2024 data from Portfolio Visualizer
// using US Large Cap Stock / US Intermediate Term Treasury data
const HistoricRates = [
  {
    "Year": 1978,
    "Inflation": 0.0902,
    "Moderate": 0.03509,
    "Balanced": 0.0398,
    "Aggressive": 0.0445,
    "Stock": 0.0587,
    "Treasury": 0.0115
  },
  {
    "Year": 1979,
    "Inflation": 0.1329,
    "Moderate": 0.117,
    "Balanced": 0.1297,
    "Aggressive": 0.1424,
    "Stock": 0.1805,
    "Treasury": 0.0535
  },
  {
    "Year": 1980,
    "Inflation": 0.1252,
    "Moderate": 0.174,
    "Balanced": 0.203,
    "Aggressive": 0.2321,
    "Stock": 0.3192,
    "Treasury": 0.0288
  },
  {
    "Year": 1981,
    "Inflation": 0.0892,
    "Moderate": 0.02102,
    "Balanced": 0.0064,
    "Aggressive": -0.0082,
    "Stock": -0.0521,
    "Treasury": 0.0941
  },
  {
    "Year": 1982,
    "Inflation": 0.0383,
    "Moderate": 0.26053,
    "Balanced": 0.2504,
    "Aggressive": 0.2402,
    "Stock": 0.2097,
    "Treasury": 0.3113
  },
  {
    "Year": 1983,
    "Inflation": 0.0379,
    "Moderate": 0.13258,
    "Balanced": 0.1486,
    "Aggressive": 0.1647,
    "Stock": 0.2129,
    "Treasury": 0.0522
  },
  {
    "Year": 1984,
    "Inflation": 0.0395,
    "Moderate": 0.10614,
    "Balanced": 0.0973,
    "Aggressive": 0.0885,
    "Stock": 0.0621,
    "Treasury": 0.1501
  },
  {
    "Year": 1985,
    "Inflation": 0.038,
    "Moderate": 0.26737,
    "Balanced": 0.2764,
    "Aggressive": 0.2853,
    "Stock": 0.3123,
    "Treasury": 0.2224
  },
  {
    "Year": 1986,
    "Inflation": 0.011,
    "Moderate": 0.16583,
    "Balanced": 0.1688,
    "Aggressive": 0.1717,
    "Stock": 0.1806,
    "Treasury": 0.151
  },
  {
    "Year": 1987,
    "Inflation": 0.0443,
    "Moderate": 0.0313,
    "Balanced": 0.0345,
    "Aggressive": 0.0376,
    "Stock": 0.0471,
    "Treasury": 0.0155
  },
  {
    "Year": 1988,
    "Inflation": 0.0442,
    "Moderate": 0.10738,
    "Balanced": 0.1183,
    "Aggressive": 0.1293,
    "Stock": 0.1622,
    "Treasury": 0.0526
  },
  {
    "Year": 1989,
    "Inflation": 0.0465,
    "Moderate": 0.22942,
    "Balanced": 0.2463,
    "Aggressive": 0.2631,
    "Stock": 0.3136,
    "Treasury": 0.1452
  },
  {
    "Year": 1990,
    "Inflation": 0.0611,
    "Moderate": 0.03068,
    "Balanced": 0.0179,
    "Aggressive": 0.0051,
    "Stock": -0.0332,
    "Treasury": 0.0946
  },
  {
    "Year": 1991,
    "Inflation": 0.0306,
    "Moderate": 0.23095,
    "Balanced": 0.2452,
    "Aggressive": 0.2595,
    "Stock": 0.3022,
    "Treasury": 0.1597
  },
  {
    "Year": 1992,
    "Inflation": 0.029,
    "Moderate": 0.07601,
    "Balanced": 0.0757,
    "Aggressive": 0.0753,
    "Stock": 0.0742,
    "Treasury": 0.0778
  },
  {
    "Year": 1993,
    "Inflation": 0.0275,
    "Moderate": 0.10662,
    "Balanced": 0.1051,
    "Aggressive": 0.1035,
    "Stock": 0.0989,
    "Treasury": 0.1143
  },
  {
    "Year": 1994,
    "Inflation": 0.0267,
    "Moderate": -0.01575,
    "Balanced": -0.0102,
    "Aggressive": -0.0047,
    "Stock": 0.0118,
    "Treasury": -0.0433
  },
  {
    "Year": 1995,
    "Inflation": 0.0254,
    "Moderate": 0.28944,
    "Balanced": 0.3064,
    "Aggressive": 0.3234,
    "Stock": 0.3745,
    "Treasury": 0.2044
  },
  {
    "Year": 1996,
    "Inflation": 0.0332,
    "Moderate": 0.12398,
    "Balanced": 0.1449,
    "Aggressive": 0.1659,
    "Stock": 0.2288,
    "Treasury": 0.0192
  },
  {
    "Year": 1997,
    "Inflation": 0.017,
    "Moderate": 0.21075,
    "Balanced": 0.235,
    "Aggressive": 0.2592,
    "Stock": 0.3319,
    "Treasury": 0.0896
  },
  {
    "Year": 1998,
    "Inflation": 0.0161,
    "Moderate": 0.19611,
    "Balanced": 0.2141,
    "Aggressive": 0.2321,
    "Stock": 0.2862,
    "Treasury": 0.1061
  },
  {
    "Year": 1999,
    "Inflation": 0.0268,
    "Moderate": 0.08773,
    "Balanced": 0.1123,
    "Aggressive": 0.1369,
    "Stock": 0.2107,
    "Treasury": -0.0352
  },
  {
    "Year": 2000,
    "Inflation": 0.0339,
    "Moderate": 0.02488,
    "Balanced": 0.0018,
    "Aggressive": -0.0213,
    "Stock": -0.0906,
    "Treasury": 0.1403
  },
  {
    "Year": 2001,
    "Inflation": 0.0155,
    "Moderate": -0.02238,
    "Balanced": -0.0419,
    "Aggressive": -0.0615,
    "Stock": -0.1202,
    "Treasury": 0.0755
  },
  {
    "Year": 2002,
    "Inflation": 0.0238,
    "Moderate": -0.03998,
    "Balanced": -0.0763,
    "Aggressive": -0.1126,
    "Stock": -0.2215,
    "Treasury": 0.1415
  },
  {
    "Year": 2003,
    "Inflation": 0.0188,
    "Moderate": 0.15435,
    "Balanced": 0.1805,
    "Aggressive": 0.2066,
    "Stock": 0.285,
    "Treasury": 0.0237
  },
  {
    "Year": 2004,
    "Inflation": 0.0326,
    "Moderate": 0.07072,
    "Balanced": 0.0781,
    "Aggressive": 0.0854,
    "Stock": 0.1074,
    "Treasury": 0.034
  },
  {
    "Year": 2005,
    "Inflation": 0.0342,
    "Moderate": 0.03544,
    "Balanced": 0.0379,
    "Aggressive": 0.0404,
    "Stock": 0.0477,
    "Treasury": 0.0231
  },
  {
    "Year": 2006,
    "Inflation": 0.0254,
    "Moderate": 0.09389,
    "Balanced": 0.1064,
    "Aggressive": 0.1189,
    "Stock": 0.1564,
    "Treasury": 0.0314
  },
  {
    "Year": 2007,
    "Inflation": 0.0408,
    "Moderate": 0.07683,
    "Balanced": 0.0722,
    "Aggressive": 0.0676,
    "Stock": 0.0539,
    "Treasury": 0.0998
  },
  {
    "Year": 2008,
    "Inflation": 0.0009,
    "Moderate": -0.1185,
    "Balanced": -0.1688,
    "Aggressive": -0.2192,
    "Stock": -0.3702,
    "Treasury": 0.1332
  },
  {
    "Year": 2009,
    "Inflation": 0.0272,
    "Moderate": 0.12396,
    "Balanced": 0.1521,
    "Aggressive": 0.1803,
    "Stock": 0.2649,
    "Treasury": -0.0169
  },
  {
    "Year": 2010,
    "Inflation": 0.015,
    "Moderate": 0.11132,
    "Balanced": 0.1189,
    "Aggressive": 0.1264,
    "Stock": 0.1491,
    "Treasury": 0.0735
  },
  {
    "Year": 2011,
    "Inflation": 0.0296,
    "Moderate": 0.05878,
    "Balanced": 0.051,
    "Aggressive": 0.0431,
    "Stock": 0.0197,
    "Treasury": 0.0979
  },
  {
    "Year": 2012,
    "Inflation": 0.0174,
    "Moderate": 0.0925,
    "Balanced": 0.1056,
    "Aggressive": 0.1188,
    "Stock": 0.1582,
    "Treasury": 0.0267
  },
  {
    "Year": 2013,
    "Inflation": 0.015,
    "Moderate": 0.14544,
    "Balanced": 0.1807,
    "Aggressive": 0.216,
    "Stock": 0.3218,
    "Treasury": -0.0309
  },
  {
    "Year": 2014,
    "Inflation": 0.0076,
    "Moderate": 0.08913,
    "Balanced": 0.0983,
    "Aggressive": 0.1075,
    "Stock": 0.1351,
    "Treasury": 0.0432
  },
  {
    "Year": 2015,
    "Inflation": 0.0073,
    "Moderate": 0.01377,
    "Balanced": 0.0135,
    "Aggressive": 0.0133,
    "Stock": 0.0125,
    "Treasury": 0.015
  },
  {
    "Year": 2016,
    "Inflation": 0.0207,
    "Moderate": 0.06501,
    "Balanced": 0.0756,
    "Aggressive": 0.0863,
    "Stock": 0.1182,
    "Treasury": 0.0119
  },
  {
    "Year": 2017,
    "Inflation": 0.0211,
    "Moderate": 0.11624,
    "Balanced": 0.1363,
    "Aggressive": 0.1564,
    "Stock": 0.2167,
    "Treasury": 0.0158
  },
  {
    "Year": 2018,
    "Inflation": 0.0191,
    "Moderate": -0.01763,
    "Balanced": -0.0232,
    "Aggressive": -0.0287,
    "Stock": -0.0453,
    "Treasury": 0.01
  },
  {
    "Year": 2019,
    "Inflation": 0.0229,
    "Moderate": 0.18807,
    "Balanced": 0.2131,
    "Aggressive": 0.2382,
    "Stock": 0.3133,
    "Treasury": 0.0629
  },
  {
    "Year": 2020,
    "Inflation": 0.0136,
    "Moderate": 0.13228,
    "Balanced": 0.1423,
    "Aggressive": 0.1524,
    "Stock": 0.1825,
    "Treasury": 0.0821
  },
  {
    "Year": 2021,
    "Inflation": 0.0704,
    "Moderate": 0.13128,
    "Balanced": 0.1621,
    "Aggressive": 0.193,
    "Stock": 0.2855,
    "Treasury": -0.0229
  },
  {
    "Year": 2022,
    "Inflation": 0.0645,
    "Moderate": -0.14332,
    "Balanced": -0.1511,
    "Aggressive": -0.1589,
    "Stock": -0.1823,
    "Treasury": -0.1043
  },
  {
    "Year": 2023,
    "Inflation": 0.0335,
    "Moderate": 0.14931,
    "Balanced": 0.1717,
    "Aggressive": 0.194,
    "Stock": 0.2611,
    "Treasury": 0.0375
  },
  {
    "Year": 2024,
    "Inflation": 0.0289,
    "Moderate": 0.13109,
    "Balanced": 0.1546,
    "Aggressive": 0.178,
    "Stock": 0.2484,
    "Treasury": 0.0138
  }
]

const BadTimingRates = [
  {
    "Year": 2000,
    "Inflation": 0.0339,
    "Moderate": 0.02488,
    "Balanced": 0.0018,
    "Aggressive": -0.0213,
    "Stock": -0.0906,
    "Treasury": 0.1403
  },
  {
    "Year": 2001,
    "Inflation": 0.0155,
    "Moderate": -0.02238,
    "Balanced": -0.0419,
    "Aggressive": -0.0615,
    "Stock": -0.1202,
    "Treasury": 0.0755
  },
  {
    "Year": 2002,
    "Inflation": 0.0238,
    "Moderate": -0.03998,
    "Balanced": -0.0763,
    "Aggressive": -0.1126,
    "Stock": -0.2215,
    "Treasury": 0.1415
  },
  {
    "Year": 2003,
    "Inflation": 0.0188,
    "Moderate": 0.15435,
    "Balanced": 0.1805,
    "Aggressive": 0.2066,
    "Stock": 0.285,
    "Treasury": 0.0237
  },
  {
    "Year": 2004,
    "Inflation": 0.0326,
    "Moderate": 0.07072,
    "Balanced": 0.0781,
    "Aggressive": 0.0854,
    "Stock": 0.1074,
    "Treasury": 0.034
  },
  {
    "Year": 2005,
    "Inflation": 0.0342,
    "Moderate": 0.03544,
    "Balanced": 0.0379,
    "Aggressive": 0.0404,
    "Stock": 0.0477,
    "Treasury": 0.0231
  },
  {
    "Year": 2006,
    "Inflation": 0.0254,
    "Moderate": 0.09389,
    "Balanced": 0.1064,
    "Aggressive": 0.1189,
    "Stock": 0.1564,
    "Treasury": 0.0314
  },
  {
    "Year": 2007,
    "Inflation": 0.0408,
    "Moderate": 0.07683,
    "Balanced": 0.0722,
    "Aggressive": 0.0676,
    "Stock": 0.0539,
    "Treasury": 0.0998
  },
  {
    "Year": 2008,
    "Inflation": 0.0009,
    "Moderate": -0.1185,
    "Balanced": -0.1688,
    "Aggressive": -0.2192,
    "Stock": -0.3702,
    "Treasury": 0.1332
  },
  {
    "Year": 2009,
    "Inflation": 0.0272,
    "Moderate": 0.12396,
    "Balanced": 0.1521,
    "Aggressive": 0.1803,
    "Stock": 0.2649,
    "Treasury": -0.0169
  },
  {
    "Year": 2010,
    "Inflation": 0.015,
    "Moderate": 0.11132,
    "Balanced": 0.1189,
    "Aggressive": 0.1264,
    "Stock": 0.1491,
    "Treasury": 0.0735
  },
  {
    "Year": 2011,
    "Inflation": 0.0296,
    "Moderate": 0.05878,
    "Balanced": 0.051,
    "Aggressive": 0.0431,
    "Stock": 0.0197,
    "Treasury": 0.0979
  },
  {
    "Year": 2012,
    "Inflation": 0.0174,
    "Moderate": 0.0925,
    "Balanced": 0.1056,
    "Aggressive": 0.1188,
    "Stock": 0.1582,
    "Treasury": 0.0267
  },
  {
    "Year": 2013,
    "Inflation": 0.015,
    "Moderate": 0.14544,
    "Balanced": 0.1807,
    "Aggressive": 0.216,
    "Stock": 0.3218,
    "Treasury": -0.0309
  },
  {
    "Year": 2014,
    "Inflation": 0.0076,
    "Moderate": 0.08913,
    "Balanced": 0.0983,
    "Aggressive": 0.1075,
    "Stock": 0.1351,
    "Treasury": 0.0432
  },
  {
    "Year": 2015,
    "Inflation": 0.0073,
    "Moderate": 0.01377,
    "Balanced": 0.0135,
    "Aggressive": 0.0133,
    "Stock": 0.0125,
    "Treasury": 0.015
  },
  {
    "Year": 2016,
    "Inflation": 0.0207,
    "Moderate": 0.06501,
    "Balanced": 0.0756,
    "Aggressive": 0.0863,
    "Stock": 0.1182,
    "Treasury": 0.0119
  },
  {
    "Year": 2017,
    "Inflation": 0.0211,
    "Moderate": 0.11624,
    "Balanced": 0.1363,
    "Aggressive": 0.1564,
    "Stock": 0.2167,
    "Treasury": 0.0158
  },
  {
    "Year": 2018,
    "Inflation": 0.0191,
    "Moderate": -0.01763,
    "Balanced": -0.0232,
    "Aggressive": -0.0287,
    "Stock": -0.0453,
    "Treasury": 0.01
  },
  {
    "Year": 2019,
    "Inflation": 0.0229,
    "Moderate": 0.18807,
    "Balanced": 0.2131,
    "Aggressive": 0.2382,
    "Stock": 0.3133,
    "Treasury": 0.0629
  },
  {
    "Year": 2020,
    "Inflation": 0.0136,
    "Moderate": 0.13228,
    "Balanced": 0.1423,
    "Aggressive": 0.1524,
    "Stock": 0.1825,
    "Treasury": 0.0821
  },
  {
    "Year": 2021,
    "Inflation": 0.0704,
    "Moderate": 0.13128,
    "Balanced": 0.1621,
    "Aggressive": 0.193,
    "Stock": 0.2855,
    "Treasury": -0.0229
  },
  {
    "Year": 2022,
    "Inflation": 0.0645,
    "Moderate": -0.14332,
    "Balanced": -0.1511,
    "Aggressive": -0.1589,
    "Stock": -0.1823,
    "Treasury": -0.1043
  },
  {
    "Year": 2023,
    "Inflation": 0.0335,
    "Moderate": 0.14931,
    "Balanced": 0.1717,
    "Aggressive": 0.194,
    "Stock": 0.2611,
    "Treasury": 0.0375
  },
  {
    "Year": 2024,
    "Inflation": 0.0289,
    "Moderate": 0.13109,
    "Balanced": 0.1546,
    "Aggressive": 0.178,
    "Stock": 0.2484,
    "Treasury": 0.0138
  },
  {
    "Year": 1978,
    "Inflation": 0.0902,
    "Moderate": 0.03509,
    "Balanced": 0.0398,
    "Aggressive": 0.0445,
    "Stock": 0.0587,
    "Treasury": 0.0115
  },
  {
    "Year": 1979,
    "Inflation": 0.1329,
    "Moderate": 0.117,
    "Balanced": 0.1297,
    "Aggressive": 0.1424,
    "Stock": 0.1805,
    "Treasury": 0.0535
  },
  {
    "Year": 1980,
    "Inflation": 0.1252,
    "Moderate": 0.174,
    "Balanced": 0.203,
    "Aggressive": 0.2321,
    "Stock": 0.3192,
    "Treasury": 0.0288
  },
  {
    "Year": 1981,
    "Inflation": 0.0892,
    "Moderate": 0.02102,
    "Balanced": 0.0064,
    "Aggressive": -0.0082,
    "Stock": -0.0521,
    "Treasury": 0.0941
  },
  {
    "Year": 1982,
    "Inflation": 0.0383,
    "Moderate": 0.26053,
    "Balanced": 0.2504,
    "Aggressive": 0.2402,
    "Stock": 0.2097,
    "Treasury": 0.3113
  },
  {
    "Year": 1983,
    "Inflation": 0.0379,
    "Moderate": 0.13258,
    "Balanced": 0.1486,
    "Aggressive": 0.1647,
    "Stock": 0.2129,
    "Treasury": 0.0522
  },
  {
    "Year": 1984,
    "Inflation": 0.0395,
    "Moderate": 0.10614,
    "Balanced": 0.0973,
    "Aggressive": 0.0885,
    "Stock": 0.0621,
    "Treasury": 0.1501
  },
  {
    "Year": 1985,
    "Inflation": 0.038,
    "Moderate": 0.26737,
    "Balanced": 0.2764,
    "Aggressive": 0.2853,
    "Stock": 0.3123,
    "Treasury": 0.2224
  },
  {
    "Year": 1986,
    "Inflation": 0.011,
    "Moderate": 0.16583,
    "Balanced": 0.1688,
    "Aggressive": 0.1717,
    "Stock": 0.1806,
    "Treasury": 0.151
  },
  {
    "Year": 1987,
    "Inflation": 0.0443,
    "Moderate": 0.0313,
    "Balanced": 0.0345,
    "Aggressive": 0.0376,
    "Stock": 0.0471,
    "Treasury": 0.0155
  },
  {
    "Year": 1988,
    "Inflation": 0.0442,
    "Moderate": 0.10738,
    "Balanced": 0.1183,
    "Aggressive": 0.1293,
    "Stock": 0.1622,
    "Treasury": 0.0526
  },
  {
    "Year": 1989,
    "Inflation": 0.0465,
    "Moderate": 0.22942,
    "Balanced": 0.2463,
    "Aggressive": 0.2631,
    "Stock": 0.3136,
    "Treasury": 0.1452
  },
  {
    "Year": 1990,
    "Inflation": 0.0611,
    "Moderate": 0.03068,
    "Balanced": 0.0179,
    "Aggressive": 0.0051,
    "Stock": -0.0332,
    "Treasury": 0.0946
  },
  {
    "Year": 1991,
    "Inflation": 0.0306,
    "Moderate": 0.23095,
    "Balanced": 0.2452,
    "Aggressive": 0.2595,
    "Stock": 0.3022,
    "Treasury": 0.1597
  },
  {
    "Year": 1992,
    "Inflation": 0.029,
    "Moderate": 0.07601,
    "Balanced": 0.0757,
    "Aggressive": 0.0753,
    "Stock": 0.0742,
    "Treasury": 0.0778
  },
  {
    "Year": 1993,
    "Inflation": 0.0275,
    "Moderate": 0.10662,
    "Balanced": 0.1051,
    "Aggressive": 0.1035,
    "Stock": 0.0989,
    "Treasury": 0.1143
  },
  {
    "Year": 1994,
    "Inflation": 0.0267,
    "Moderate": -0.01575,
    "Balanced": -0.0102,
    "Aggressive": -0.0047,
    "Stock": 0.0118,
    "Treasury": -0.0433
  },
  {
    "Year": 1995,
    "Inflation": 0.0254,
    "Moderate": 0.28944,
    "Balanced": 0.3064,
    "Aggressive": 0.3234,
    "Stock": 0.3745,
    "Treasury": 0.2044
  },
  {
    "Year": 1996,
    "Inflation": 0.0332,
    "Moderate": 0.12398,
    "Balanced": 0.1449,
    "Aggressive": 0.1659,
    "Stock": 0.2288,
    "Treasury": 0.0192
  },
  {
    "Year": 1997,
    "Inflation": 0.017,
    "Moderate": 0.21075,
    "Balanced": 0.235,
    "Aggressive": 0.2592,
    "Stock": 0.3319,
    "Treasury": 0.0896
  },
  {
    "Year": 1998,
    "Inflation": 0.0161,
    "Moderate": 0.19611,
    "Balanced": 0.2141,
    "Aggressive": 0.2321,
    "Stock": 0.2862,
    "Treasury": 0.1061
  },
  {
    "Year": 1999,
    "Inflation": 0.0268,
    "Moderate": 0.08773,
    "Balanced": 0.1123,
    "Aggressive": 0.1369,
    "Stock": 0.2107,
    "Treasury": -0.0352
  }
]


export default RateModels